// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tab__container___y5HAF {
    display: flex;
    flex: 0 0 13.4rem;
    align-items: center;
    justify-content: space-between;

    padding: 0.4rem 0.8rem;

    background: var(--color-bg-secondary);
    box-shadow: inset -0.1rem 0 0 var(--color-bg-border);

    transition: border-radius var(--geomate-time-duration) var(--geomate-time-function);
}

.Tab__tab___yTSom {
    display: flex;
    align-items: center;

    font-size: 1.2rem;
    color: var(--color-typo-secondary);

    background: none;
    border: none;
}

.Tab__tab___yTSom .Tab__icon___FEyVb {
    fill: var(--color-typo-ghost);
}

.Tab__anchor___CpybQ {
    visibility: hidden;
}

.Tab__container___y5HAF:hover {
    background: var(--color-bg-stripe);
}

.Tab__container___y5HAF:hover .Tab__tab___yTSom {
    color: var(--color-typo-secondary);
}

.Tab__selected___gSyGZ,
.Tab__selected___gSyGZ:hover {
    background: var(--color-bg-default);
}

.Tab__container___y5HAF.Tab__selected___gSyGZ .Tab__tab___yTSom,
.Tab__selected___gSyGZ:hover .Tab__tab___yTSom {
    color: var(--color-typo-primary);
}

.Tab__container___y5HAF.Tab__active___aNVmk {
    border-radius: 0 0.4rem 0 0;
}

.Tab__container___y5HAF.Tab__active___aNVmk .Tab__tab___yTSom,
.Tab__active___aNVmk:hover .Tab__tab___yTSom {
    color: var(--color-control-typo-secondary);
}

.Tab__selected___gSyGZ .Tab__icon___FEyVb,
.Tab__container___y5HAF:hover .Tab__icon___FEyVb {
    fill: var(--color-control-typo-ghost);
}

.Tab__selected___gSyGZ .Tab__anchor___CpybQ,
.Tab__container___y5HAF:hover .Tab__anchor___CpybQ {
    visibility: visible;
}

.Tab__label___rVs1l {
    overflow: hidden;
    width: 7rem;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.Tab__iconMargin___AfE8H {
    margin-right: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/WorkAreas/Tab/Tab.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;;IAE9B,sBAAsB;;IAEtB,qCAAqC;IACrC,oDAAoD;;IAEpD,mFAAmF;AACvF;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,iBAAiB;IACjB,kCAAkC;;IAElC,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":[".container {\n    display: flex;\n    flex: 0 0 13.4rem;\n    align-items: center;\n    justify-content: space-between;\n\n    padding: 0.4rem 0.8rem;\n\n    background: var(--color-bg-secondary);\n    box-shadow: inset -0.1rem 0 0 var(--color-bg-border);\n\n    transition: border-radius var(--geomate-time-duration) var(--geomate-time-function);\n}\n\n.tab {\n    display: flex;\n    align-items: center;\n\n    font-size: 1.2rem;\n    color: var(--color-typo-secondary);\n\n    background: none;\n    border: none;\n}\n\n.tab .icon {\n    fill: var(--color-typo-ghost);\n}\n\n.anchor {\n    visibility: hidden;\n}\n\n.container:hover {\n    background: var(--color-bg-stripe);\n}\n\n.container:hover .tab {\n    color: var(--color-typo-secondary);\n}\n\n.selected,\n.selected:hover {\n    background: var(--color-bg-default);\n}\n\n.container.selected .tab,\n.selected:hover .tab {\n    color: var(--color-typo-primary);\n}\n\n.container.active {\n    border-radius: 0 0.4rem 0 0;\n}\n\n.container.active .tab,\n.active:hover .tab {\n    color: var(--color-control-typo-secondary);\n}\n\n.selected .icon,\n.container:hover .icon {\n    fill: var(--color-control-typo-ghost);\n}\n\n.selected .anchor,\n.container:hover .anchor {\n    visibility: visible;\n}\n\n.label {\n    overflow: hidden;\n    width: 7rem;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.iconMargin {\n    margin-right: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Tab__container___y5HAF`,
	"tab": `Tab__tab___yTSom`,
	"icon": `Tab__icon___FEyVb`,
	"anchor": `Tab__anchor___CpybQ`,
	"selected": `Tab__selected___gSyGZ`,
	"active": `Tab__active___aNVmk`,
	"label": `Tab__label___rVs1l`,
	"iconMargin": `Tab__iconMargin___AfE8H`
};
export default ___CSS_LOADER_EXPORT___;
